import { createSelector } from 'reselect'

export const selectServicesStatus = state => state.servicesStatus

export const selectServicesStatusList = createSelector(
  selectServicesStatus,
  usersManagement => usersManagement.services,
)
